var bts = angular.module("bootstrap.ebusiness", []);
bts.run(["$cookies", "navigation", "brand", "sessionData", "hook", "link",  function($cookies, navigation, brand, sessionData, hook, link) {
	var brandFilter = navigation.setFilter("brand", function(item) {
		if (Array.isArray(item.filterData.brand)) {

			return ~item.filterData.brand.indexOf(brand.current.sharedBrandCode) || ~item.filterData.brand.indexOf('*');
		}
		else {
			return brand.current.sharedBrandCode === item.filterData.brand;
		}
	});
	var postPasswordFilter = navigation.setFilter("postPassword", function(item) {
		return (sessionData.loggedIn && item.filterData.postPassword) || (!sessionData.loggedIn && !item.filterData.postPassword);
	});
	var tempPasswordFilter = navigation.setFilter("tempPassword", function(item) {
		return (sessionData.tempPassword && item.filterData.tempPassword) || (!sessionData.tempPassword && !item.filterData.tempPassword);
	});
	var msiteFilter = navigation.setFilter("msite", function(item) {
		if (!sessionData.loggedIn) {
			return true;
		}
		if ($cookies.get('mobileUser') === "true") {
			if (item.mSite) {
				item.url = item.mSite;
				return item;
			}
			else {
				return false;
			}
		}
		return true;
	});

	hook.register('sessionStart', ["$cookies", "teamsite", "brand", "coremetrics", "services", "$q", "sessionData", "brandConfig", "$interval", "session", "appConfig", "$state", "appId", function($cookies, teamsite, brand, coremetrics, services, $q, sessionData, brandConfig, $interval, session, appConfig, $state, appId) {
		//if(!session.isEmaterials()) {
        if(['CHMEMA', 'CLXCLP', 'SVYWEB'].indexOf(appId.toUpperCase()) != -1) {
            if(appId.toUpperCase() == 'CHMEMA'){
                return;
            }
            if(appId.toUpperCase() === 'SVYWEB'){
                return;
            }
			if (sessionData.loggedIn > 0 || sessionData.loggingIn) {
				return hook.execute("clientPortalSessionStart").then(function () {
					coremetrics.postPasswordClientStart();
				});
			}
        }
        else {

            teamsite.addBlocker('session');

            return $q.all({
                'basicInfo': services.rbsmbl.basicInfo().fetch()
            }).then(function (responses) {
                if (responses.basicInfo.data && responses.basicInfo.data.payload && responses.basicInfo.data.payload.basicInfo && responses.basicInfo.data.payload.basicInfo.role && responses.basicInfo.data.payload.basicInfo.role.toLowerCase) {
                    // basicinfo roles
                    // demouser
                    // agent
                    // ba
                    // bacancelled
                    // internal
                    // csr
                    // agency_admin
                    // visitor
                    // member
                    sessionData.basicInfo = angular.copy(responses.basicInfo.data.payload.basicInfo);

                    // Start coremetrics
					switch (sessionData.basicInfo.role.toLowerCase()) {
						case "member":
							coremetrics.postPasswordMemberStart();
							break;
						case "agent":
						case "agency_admin":
							coremetrics.postPasswordProducerStart();
							break;
						case "ba":
						case "bacancelled":
						case "sba":
						case "mcu_admin":
							coremetrics.postPasswordEmployerStart();
							break;
						default:
							break;
					}

                    return hook.execute("eBusinessSessionStart").then(function () {
                        // Reserved for future use
                    }, function(error) {
                        teamsite.removeBlocker('session');
                        return $q.reject(error);
                    });
                }
            }).then(function () {
                teamsite.removeBlocker('session');
            });
        }
	}]);

	hook.register('sessionEnd', ["$cookies", "teamsite", "brand", "coremetrics", "services", "$q", "sessionData", "brandConfig", "$interval", "session", "appConfig", "appId", function($cookies, teamsite, brand, coremetrics, services, $q, sessionData, brandConfig, $interval, session, appConfig, appId) {
        // Start
		if(['CHMEMA', 'CLXCLP'].indexOf(appId.toUpperCase()) != -1) {
			if(appId.toUpperCase() == 'CHMEMA'){
				return;
			}
			return hook.execute("clientPortalSessionEnd").then(function () {
				// Reserved for future use
				coremetrics.postPasswordClientEnd();
			});
		}
        else if (appId.toUpperCase() == 'CHMMDR') {
            coremetrics.postPasswordD20End();
        }
		else if (sessionData && sessionData.basicInfo && sessionData.basicInfo.role && sessionData.basicInfo.role.toLowerCase()) {
			switch (sessionData.basicInfo.role.toLowerCase()) {
				case "member":
					coremetrics.postPasswordMemberEnd();
					break;
				case "agent":
				case "agency_admin":
					coremetrics.postPasswordProducerEnd();
					break;
				case "ba":
				case "bacancelled":
				case "sba":
				case "mcu_admin":
					coremetrics.postPasswordEmployerEnd();
					break;
				default:
					coremetrics.postPasswordMemberEnd();
					break;
			}
        }
        else {
			coremetrics.postPasswordMemberEnd();
        }

        return $q.all({
            'appConfig': appConfig.getAll()
        }).then(function(responses) {
    		sessionData.appConfig = angular.extend({}, responses.appConfig);
			return hook.execute("eBusinessSessionEnd").then(function() {
				// Reserved for future use
			});
        });
	}]);


	var Facebook = link.set("Facebook", {
		"title":"Facebook",
		"imgPath": "icon-facebook-34px.png",
		"url" : "http://www.facebook.com/Highmark",
		"newWindow": true,
		"filterData": {
			"brand": ["hmbcbs", "hbs", "hmbcbswv", "hhic", "hmbcbsde", "nepa", "unbrandedhm"]
		}
	});
	var Twitter = link.set("Twitter", {
		"title":"Twitter",
		"imgPath": "icon-twitter-34px.png",
		"url" : "http://www.twitter.com/highmark",
		"newWindow": true,
		"filterData": {
			"brand": ["hmbcbs", "hbs", "hmbcbswv", "hhic", "hmbcbsde", "nepa", "unbrandedhm"]
		}
	});
	var YouTube = link.set("YouTube", {
		"title":"You Tube",
		"imgPath": "icon-youtube-34px.png",
		"url" : "http://www.youtube.com/user/highmarkhealthy?feature=results_main",
		"newWindow": true,
		"filterData": {
			"brand": ["hmbcbs", "hbs", "hmbcbswv", "hhic", "hmbcbsde", "nepa", "unbrandedhm"]
		}
	});
	var Pinterest = link.set("Pinterest", {
		"title":"Pinterest",
		"imgPath": "icon-pinterest-34px.png",
		"url" : "http://pinterest.com/highmark",
		"newWindow": true,
		"filterData": {
			"brand": ["hmbcbs", "hbs", "hmbcbswv", "hhic", "hmbcbsde", "nepa", "unbrandedhm"]
		}
	});
	var LinkedIn = link.set("LinkedIn", {
		"title":"LinkedIn",
		"imgPath": "icon-linkedin-34px.png",
		"url" : "http://linkedin.com/company/highmark",
		"newWindow": true,
		"filterData": {
			"brand": ["hmbcbs", "hbs", "hmbcbswv", "hhic", "hmbcbsde", "nepa", "unbrandedhm"]
		}
	});
	var Blog = link.set("Blog", {
		"title":"Blog",
		"imgPath": "icon-blog-34px.png",
		"url" : "http://blog.highmark.com/",
		"newWindow": true,
		"filterData": {
			"brand": ["hmbcbs", "hbs", "hmbcbswv", "hhic", "hmbcbsde", "nepa", "unbrandedhm"]
		}
	});
	var InstaGram = link.set("InstaGram", {
		"title":"InstaGram",
		"imgPath": "Instagram34px.png",
		"url" : "http://www.instagram.com/highmark",
		"newWindow": true,
		"filterData": {
			"brand": ["hmbcbs", "hbs", "hmbcbswv", "hhic", "hmbcbsde", "nepa", "unbrandedhm"]
		}
	});
	var FacebookMN = link.set("FacebookMN", {
		"title":"Facebook",
		"imgPath": "icon-facebook-34px.png",
		"url" : "http://www.facebook.com/bluecrossmn",
		"newWindow": true,
		"filterData": {
			"brand": ["mincr","9014"]
		}
	});
	var TwitterMN = link.set("TwitterMN", {
		"title":"Twitter",
		"imgPath": "icon-twitter-34px.png",
		"url" : "http://www.twitter.com/bluecrossmn",
		"newWindow": true,
		"filterData": {
			"brand": ["mincr","9014"]
		}
	});
	var YouTubeMN = link.set("YouTubeMN", {
		"title":"You Tube",
		"imgPath": "icon-youtube-34px.png",
		"url" : "http://www.youtube.com/user/BlueCrossofMN?feature=results_main",
		"newWindow": true,
		"filterData": {
			"brand": ["mincr","9014"]
		}
	});
	var LinkedInMN = link.set("LinkedInMN", {
		"title":"LinkedIn",
		"imgPath": "icon-linkedin-34px.png",
		"url" : "http://www.linkedin.com/company/blue-cross-blue-shield-of-minnesota",
		"newWindow": true,
		"filterData": {
			"brand": ["mincr","9014"]
		},
		"filters" : [function(item) {
			if (sessionData.loggedIn) {
				if (sessionData.basicInfo && sessionData.basicInfo.role && sessionData.basicInfo.role.toLowerCase) {
					if (~["ba", "bacancelled", "agent", "agency_admin"].indexOf(sessionData.basicInfo.role.toLowerCase())) {
						item.url = "https://www.linkedin.com/company/blue-cross-and-blue-shield-of-minnesota-large-group?trk=biz-brand-tree-co-name"
						return item;
					}
				}
			}
			return true;
		}]
	});

	//new
	var FacebookND = link.set("FacebookND", {
		"title":"Facebook",
		"imgPath": "icon-facebook-34px.png",
		"url" : "https://www.facebook.com/bcbsnd",
		"newWindow": true,
		"filterData": {
			"brand": ["ndbcbs"]
		}
	});
	var TwitterND = link.set("TwitterND", {
		"title":"Twitter",
		"imgPath": "icon-twitter-34px.png",
		"url" : "https://twitter.com/BCBSND",
		"newWindow": true,
		"filterData": {
			"brand": ["ndbcbs"]
		}
	});
	var YouTubeND = link.set("YouTubeND", {
		"title":"You Tube",
		"imgPath": "icon-youtube-34px.png",
		"url" : "http://www.youtube.com/BlueCrossND",
		"newWindow": true,
		"filterData": {
			"brand": ["ndbcbs"]
		}
	});
	var LinkedInND = link.set("LinkedInND", {
		"title":"LinkedIn",
		"imgPath": "icon-linkedin-34px.png",
		"url" : "https://www.linkedin.com/company/blue-cross-blue-shield-of-north-dakota",
		"newWindow": true,
		"filterData": {
			"brand": ["ndbcbs"]
		},
		"filters" : [function(item) {
			if (sessionData.loggedIn) {
				if (sessionData.basicInfo && sessionData.basicInfo.role && sessionData.basicInfo.role.toLowerCase) {
					if (~["ba", "bacancelled", "agent", "agency_admin"].indexOf(sessionData.basicInfo.role.toLowerCase())) {
						item.url = "https://www.linkedin.com/company/blue-cross-blue-shield-of-north-dakota-large-group?trk=biz-brand-tree-co-name"
						return item;
					}
				}
			}
			return true;
		}]
	});
	//end
    //wy
    var FacebookWY = link.set("FacebookWY", {
        "title":"Facebook",
        "imgPath": "icon-facebook-34px.png",
        "url" : "https://www.facebook.com/bcbswy",
        "newWindow": true,
        "filterData": {
            "brand": ["wybcbs"]
        }
    });
    var TwitterWY = link.set("TwitterWY", {
        "title":"Twitter",
        "imgPath": "icon-twitter-34px.png",
        "url" : "https://twitter.com/BCBSWY",
        "newWindow": true,
        "filterData": {
            "brand": ["wybcbs"]
        }
    });
    var YouTubeWY = link.set("YouTubeWY", {
        "title":"You Tube",
        "imgPath": "icon-youtube-34px.png",
        "url" : "https://www.youtube.com/channel/UCZMHdVZqhSwP8RBQ3_IdDdg",
        "newWindow": true,
        "filterData": {
            "brand": ["wybcbs"]
        }
	});
	//NENY
    var FacebookNENY = link.set("FacebookNENY", {
        "title":"Facebook",
        "imgPath": "icon-facebook-34px.png",
        "url" : "https://www.facebook.com/BSNENY",
        "newWindow": true,
        "filterData": {
            "brand": ["neny"]
        }
    });
    var TwitterNENY = link.set("TwitterNENY", {
        "title":"Twitter",
        "imgPath": "icon-twitter-34px.png",
        "url" : "https://twitter.com/bsneny/",
        "newWindow": true,
        "filterData": {
            "brand": ["neny"]
        }
    });
    var YouTubeNENY = link.set("YouTubeNENY", {
        "title":"You Tube",
        "imgPath": "icon-youtube-34px.png",
        "url" : "https://www.youtube.com/channel/UCeilh8gfeobHQwGC5fvKa2g",
        "newWindow": true,
        "filterData": {
            "brand": ["neny"]
        }
	});
	var InstaGramNENY = link.set("InstaGramNENY", {
		"title":"InstaGram",
		"imgPath": "Instagram34px.png",
		"url" : "https://www.instagram.com/bsneny/",
		"newWindow": true,
		"filterData": {
			"brand": ["neny"]
		}
	});
	//WNY
    var FacebookWNY = link.set("FacebookWNY", {
        "title":"Facebook",
        "imgPath": "icon-facebook-34px.png",
        "url" : "https://www.facebook.com/BCBSofWNY/",
        "newWindow": true,
        "filterData": {
            "brand": ["wny"]
        }
    });
    var TwitterWNY = link.set("TwitterWNY", {
        "title":"Twitter",
        "imgPath": "icon-twitter-34px.png",
        "url" : "https://twitter.com/bcbswny/",
        "newWindow": true,
        "filterData": {
            "brand": ["wny"]
        }
    });
    var YouTubeWNY = link.set("YouTubeWNY", {
        "title":"You Tube",
        "imgPath": "icon-youtube-34px.png",
        "url" : "https://www.youtube.com/channel/UCMv4S_8j4CejLdtWyiaPgOw",
        "newWindow": true,
        "filterData": {
            "brand": ["wny"]
        }
    });
    var LinkedInWNY = link.set("LinkedInWNY", {
        "title":"LinkedIn",
        "imgPath": "icon-linkedin-34px.png",
        "url" : "https://www.linkedin.com/company/bluecross-blueshield-of-western-new-york",
        "newWindow": true,
        "filterData": {
            "brand": ["wny"]
        }
	});
	var InstaGramWNY = link.set("InstaGramWNY", {
		"title":"InstaGram",
		"imgPath": "Instagram34px.png",
		"url" : "https://www.instagram.com/bcbswny/",
		"newWindow": true,
		"filterData": {
			"brand": ["wny"]
		}
	});

    var LinkedInWY = link.set("LinkedInWY", {
        "title":"LinkedIn",
        "imgPath": "icon-linkedin-34px.png",
        "url" : "http://www.linkedin.com/company/blue-cross-blue-shield-of-wyoming",
        "newWindow": true,
        "filterData": {
            "brand": ["wybcbs"]
        },
        "filters" : [function(item) {
            if (sessionData.loggedIn) {
                if (sessionData.basicInfo && sessionData.basicInfo.role && sessionData.basicInfo.role.toLowerCase) {
                    if (~["ba", "bacancelled", "agent", "agency_admin"].indexOf(sessionData.basicInfo.role.toLowerCase())) {
                        item.url = "https://www.linkedin.com/company/blue-cross-blue-shield-of-wyoming-large-group?trk=biz-brand-tree-co-name"
                        return item;
                    }
                }
            }
            return true;
        }]
    });


	var socialLinks = navigation.set("socialLinks");
	socialLinks.linkFilters.push("brand", "tempPassword");
	socialLinks.links.push(
		Facebook, Twitter, YouTube, Pinterest, LinkedIn, Blog, InstaGram,
		FacebookMN, TwitterMN, YouTubeMN, LinkedInMN,
		FacebookND, TwitterND, YouTubeND, LinkedInND,
        FacebookWY, TwitterWY, YouTubeWY, LinkedInWY,
		FacebookNENY, TwitterNENY,  YouTubeNENY, InstaGramNENY,
		FacebookWNY, TwitterWNY, YouTubeWNY, LinkedInWNY, InstaGramWNY
	);






}]);
